import React, { useState } from 'react'
import { Box, Button, FormControl, InputLabel, TextField, Typography } from '@mui/material'
// import eye from '../../assets/Project_Images/Icons/eye.png'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import { useFormik } from 'formik'
import * as Yup from "yup"
import { Password, VisibilityOffOutlined } from '@mui/icons-material'
import password from '../../assets/common/images/password.png'
import { useDispatch, useSelector } from 'react-redux'
import { toast } from 'react-toastify'
import { Images } from '../../global/GloblImages'
import { ApiResetPassword } from '../../apiService/Core/Apicall'
import storage from '../../utils/storage'


interface FormValues {
    newpassword: string;
    confirmpassword: string;
}

const SetPassword: React.FC = () => {
    const dispatch = useDispatch()
    const location = useLocation()
    const [showpassword, setshowpassword] = useState<boolean>(false)
    const [showerror, setshowerror] = useState<boolean>(false);

    const [showpassword2, setshowpassword2] = useState<boolean>(false)
    const [strength, setStrength] = useState<string>("");
    const [strong, setStrong] = useState<number>(0);
    const navigate = useNavigate()
    const { MMLogo } = Images()
    const initialValues: FormValues = {
        newpassword: '',
        confirmpassword: '',
    }
    const keyup = (e: any) => {
        if (e.code === "Enter") {
            formik.handleSubmit();
        }
    };
    const onSubmit = async (values: FormValues) => {
        if (values.newpassword === values.confirmpassword) {

            const Apidata = {
                emailId: storage.getItem('emailId'),
                password: values.confirmpassword,
            }
            try {
                const response: any = await ApiResetPassword(Apidata);
                if (response.status) {
                    // toast.success(response.message)
                    navigate('/login')
                }

            }
            catch (error) {
                alert(error)
            }
        }
        else {
            alert('password should be same')
        }
    }
    const validationSchema = Yup.object({
        newpassword: Yup.string().min(8, "Password must be at least 8 characters long").required("Password is required"),
        confirmpassword: Yup.string()
            .min(8, "Password must be at least 8 characters long")
            .required("Password is required"),
    });
    const formik = useFormik<FormValues>({
        initialValues,
        onSubmit,
        validationSchema,
        validateOnChange: true,
        validateOnBlur: false,
    })
    const passwordstrength = (event: any) => {
        const pass = event.target.value;
        formik.setFieldValue('newpassword', pass);
        if (pass.match(/(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&*])/)) {
            setStrength("strong");
            setStrong(100);
        } else if (pass.match(/(?=.*[0-9])(?=.*[a-zA-Z])/)) {
            setStrength("medium");
            setStrong(66);
        } else if (pass.match(/(?=.*[a-zA-Z])/)) {
            setStrength("weak");
            setStrong(33);
        } else {
            setStrength("");
            setStrong(0);
        }
    };
    return (
        <Box className='d-flex flex-column w-100 align-items-center'>
            <Box component='img' className='mb-2' width='40%' zIndex={2} src={MMLogo} height='auto' alt='logo' />
            <Box className='flex-grow-1 w-100'>
                <Typography className='text-main fs-3 fw-bold'>Set Password</Typography>
                <Typography className='fs-18'>Create a strong password to protect your account and access your insights safely.</Typography>
                <Box className='mt-5 input-border'>
                    <form onSubmit={formik.handleSubmit}>

                        <FormControl className='col-12 mb-3'>
                            <label className='label'>
                                <span>New Password{" "}
                                    <sup>
                                        <i className="fa-solid fa-star-of-life star"></i>
                                    </sup>
                                </span>
                            </label>                            
                            <TextField
                                type={showpassword ? 'text' : 'password'}
                                value={formik.values.newpassword}
                                onChange={(e) => { passwordstrength(e) }}
                                className='custom-textfield'
                                sx={{"& fieldset":{border:"1px solid black !important"}}}

                                slotProps={{
                                    input: {
                                        // startAdornment: <Box component='img' src={password} height='24px' width='24px' />,
                                        endAdornment: <Button onClick={() => { setshowpassword(!showpassword) }}><VisibilityOffOutlined /></Button>
                                    }
                                }}
                            // {...formik.getFieldProps("newpassword")}
                            ></TextField>
                        <Typography className="error ">
                            {showerror && formik.errors.newpassword ? (
                                <Typography className="error text-danger" variant='caption'>
                                    {formik.errors.newpassword}
                                </Typography>
                            ) : null}
                        </Typography>
                        </FormControl>
                        <FormControl className='col-12'>
                              <label className='label'>
                                <span>Confirm Password{" "}
                                    <sup>
                                        <i className="fa-solid fa-star-of-life star"></i>
                                    </sup>
                                </span>
                            </label>
                            <TextField
                                type={showpassword2 ? 'text' : 'password'}
                                className='custom-textfield'
                                sx={{"& fieldset":{border:"1px solid black !important"}}}
                                slotProps={{
                                    input: {
                                        // startAdornment: <Box component='img' src={password} height='24px' width='24px' />,
                                        endAdornment: <Button onClick={() => { setshowpassword2(!showpassword2) }}><VisibilityOffOutlined /></Button>
                                    }
                                }}
                               
                                {...formik.getFieldProps("confirmpassword")}

                            ></TextField>
                            <Typography className="error ">
                                {showerror && formik.errors.confirmpassword ? (
                                    <Typography className="error text-danger" variant='caption'>
                                        {formik.errors.confirmpassword}
                                    </Typography>
                                ) : null}
                            </Typography>
                            <Box
                                component="div" // Specify the component type
                                width='100%'
                                display='flex'
                                my='10px'
                                justifyContent='space-between'

                            >
                                <style>{
                                    `
                            progress::-webkit-progress-value {
                                        background-color: ${strong === 33 ? "red" : strong === 66 ? "yellow" : ""
                                    } ; 
                            border-radius: 10px;
                                }
                            `}
                                </style>
                                <progress
                                    value={strong}
                                    max="25"
                                    style={{ height: '8px' }}
                                    className="progress  mx-1 border-50"
                                ></progress>
                                <progress
                                    value={strong - 25}
                                    max="25"
                                    style={{ height: '8px' }}
                                    className="progress mx-1 border-50"
                                ></progress>
                                <progress
                                    value={strong - 50}
                                    max="25"
                                    style={{ height: '8px' }}
                                    className="progress mx-1 border-50"
                                ></progress>
                                <progress
                                    value={strong - 75}
                                    max="25"
                                    style={{ height: '8px' }}
                                    className="progress mx-1 border-50"
                                ></progress>
                            </Box>
                            <Typography className="text-main">
                                Password Strength : {strength}
                            </Typography>
                        </FormControl>

                        <Button type='submit' onClick={() => setshowerror(true)} fullWidth className='button-primary mt-5 py-2'>Submit</Button>
                    </form>
                </Box>
            </Box>
        </Box>
    )
}

export default SetPassword
